import { configureStore } from "@reduxjs/toolkit";
import appSlice from "./appSlice";
import BlogSlice from "./BlogSlice";
import loginSlice from "./loginSlice";
import verifyblogSlice from "./verifyblogSlice";
import reloadSlice from "./reloadSlice";
import editformslice from "./editformslice";
import affiliateFormSlice from "./affiliateFormSlice";
import verifyAffiliateSlice from "./verifyAffiliateSlice";
import libraryAddSclice from "./libraryAddSclice";
import meditationAddSlice from "./meditationAddSlice";
import meditationEditSlice from "./meditationEditSlice";
import sandhayaEditSlice from "./sandhayaEditSlice";
import sandhayaAddSclice from "./sandhayaAddSclice";
import todaySandhayaSlice from "./todaySandhayaSlice";
import emotionAddSlice from "./emotionAddSlice";
import emotionEditSlice from "./emotionEditSlice";
import dailyQuotesSlice from "./dailyQuotesSlice";
import onlineEventSlice from "./onlineEventSlice";
import libraryEditSlice from "./libraryEditSlice";
import mantraAddSlice from './mantraAddSlice';
import verifyMantraSlice from './verifyMantraSlice';
import editMantraSlice from './editMantraSlice';

const store = configureStore({
  reducer: {
    app: appSlice,
    login: loginSlice,
    reload: reloadSlice,
    verifyblog: verifyblogSlice,
    blog: BlogSlice,
    editblog: editformslice,
    affiliateForm: affiliateFormSlice,
    verifyAffiliate: verifyAffiliateSlice,
    libraryAdd: libraryAddSclice,
    meditationAdd: meditationAddSlice,
    meditationEdit: meditationEditSlice,
    sandhayaAdd: sandhayaAddSclice,
    sandhayaEdit: sandhayaEditSlice,
    todaySandhayaAdd: todaySandhayaSlice,
    emotionAdd: emotionAddSlice,
    emotionEdit: emotionEditSlice,
    dailyQuotes: dailyQuotesSlice,
    onlineEvent: onlineEventSlice,
    libraryEdit: libraryEditSlice,
    mantraAdd: mantraAddSlice,
    verifyMantra: verifyMantraSlice,
    editMantra: editMantraSlice,
  },
});

export default store;